import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Share2, Link as LinkIcon, Check, Mail } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';

interface ShareMenuProps {
  url: string;
  title: string;
  text?: string;
  className?: string;
  align?: 'left' | 'right';
}

// Icone brand a zero dipendenze (SVG inline).
const WhatsAppIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
  </svg>
);
const TelegramIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.820 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);
const XIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const LinkedInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);
const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);
const RedditIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 11.779c0-1.459-1.192-2.645-2.657-2.645-.715 0-1.363.286-1.84.746-1.81-1.191-4.259-1.949-6.971-2.046l1.483-4.669 4.016.941-.006.058c0 1.193.975 2.163 2.174 2.163 1.198 0 2.172-.97 2.172-2.163s-.975-2.164-2.172-2.164c-.92 0-1.704.574-2.021 1.379l-4.329-1.015c-.189-.046-.381.063-.44.249l-1.654 5.207c-2.863.05-5.46.809-7.35 2.05-.475-.458-1.121-.742-1.833-.742z" />
  </svg>
);

const NETWORKS = [
  { name: 'WhatsApp', Icon: WhatsAppIcon, color: '#25D366', href: (u: string, t: string) => `https://api.whatsapp.com/send?text=${encodeURIComponent(`${t} ${u}`)}` },
  { name: 'Telegram', Icon: TelegramIcon, color: '#26A5E4', href: (u: string, t: string) => `https://t.me/share/url?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}` },
  { name: 'X (Twitter)', Icon: XIcon, color: 'currentColor', href: (u: string, t: string) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}` },
  { name: 'LinkedIn', Icon: LinkedInIcon, color: '#0A66C2', href: (u: string) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(u)}` },
  { name: 'Facebook', Icon: FacebookIcon, color: '#1877F2', href: (u: string) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}` },
  { name: 'Reddit', Icon: RedditIcon, color: '#FF4500', href: (u: string, t: string) => `https://www.reddit.com/submit?url=${encodeURIComponent(u)}&title=${encodeURIComponent(t)}` },
  { name: 'Email', Icon: Mail, color: 'currentColor', href: (u: string, t: string) => `mailto:?subject=${encodeURIComponent(t)}&body=${encodeURIComponent(u)}` },
] as const;

export function ShareMenu({ url, title, text, className = '', align = 'right' }: ShareMenuProps) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

  const shareText = text ?? title;

  useEffect(() => {
    if (!open) return;
    const compute = () => {
      const r = triggerRef.current?.getBoundingClientRect();
      if (!r) return;
      const top = r.bottom + 8;
      const left = align === 'right' ? r.right - 288 : r.left;
      setPos({ top, left: Math.max(8, Math.min(left, window.innerWidth - 296)) });
    };
    compute();
    const onDown = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node) && !triggerRef.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('scroll', compute, true);
    window.addEventListener('resize', compute);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('scroll', compute, true);
      window.removeEventListener('resize', compute);
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open, align]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard non disponibile */ }
  };

  const nativeShare = async () => {
    if (!navigator.share) return;
    const payload: ShareData = { url, title };
    if (text) payload.text = text;

    // canShare: alcuni browser espongono share ma rifiutano questo payload
    // (es. url non supportato) -> si va diretti al fallback copia.
    if (typeof navigator.canShare === 'function' && !navigator.canShare(payload)) {
      await copy();
      return;
    }

    try {
      await navigator.share(payload);
      setOpen(false);
    } catch (err) {
      // AbortError = utente ha annullato il foglio: nessun fallback, nessun rumore.
      const name = (err as { name?: string } | null)?.name;
      if (name === 'AbortError') return;
      // Altri errori (NotAllowedError senza gesto, DataError, TypeError) -> copia link.
      await copy();
    }
  };

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        onPointerDown={(e) => e.stopPropagation()}
        aria-label={t('social', 'share') || 'Condividi'}
        aria-haspopup="dialog"
        aria-expanded={open}
        title={t('social', 'share') || 'Condividi'}
        className={`w-10 h-10 rounded-full bg-black/50 hover:bg-black/80 backdrop-blur-md flex items-center justify-center text-white border border-white/20 shadow-lg transition-colors cursor-pointer ${className}`}
      >
        <Share2 size={18} />
      </button>

      {open && pos && createPortal(
        <div
          ref={menuRef}
          role="dialog"
          aria-label={t('social', 'share') || 'Condividi'}
          className="fixed z-[70] w-72 rounded-2xl border border-white/12 bg-zinc-900/95 backdrop-blur-xl shadow-2xl p-3 text-white"
          style={{ top: pos.top, left: pos.left }}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <div className="text-[11px] font-bold uppercase tracking-widest text-white/50 px-1 mb-2">
            {t('social', 'label') || 'Condividi:'}
          </div>

          {typeof navigator !== 'undefined' && 'share' in navigator && (
            <button
              type="button"
              onClick={nativeShare}
              className="w-full mb-2 flex items-center gap-2 px-3 py-2 rounded-xl bg-white/10 hover:bg-white/20 text-sm font-semibold transition-colors cursor-pointer"
            >
              <Share2 size={16} /> {t('social', 'share_native') || 'Condividi…'}
            </button>
          )}

          <div className="grid grid-cols-4 gap-1.5">
            {NETWORKS.map(({ name, Icon, color, href }) => (
              <a
                key={name}
                href={href(url, shareText)}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={(t('social', 'share_on') || 'Condividi su {{name}}').replace('{{name}}', name)}
                title={name}
                className="flex flex-col items-center gap-1 py-2 rounded-xl hover:bg-white/10 transition-colors no-underline text-white/90"
              >
                <span style={{ color }}><Icon /></span>
                <span className="text-[9px] leading-none text-white/60">{name.split(' ')[0]}</span>
              </a>
            ))}
            <button
              type="button"
              onClick={copy}
              aria-label={t('social', 'copy_link_aria') || 'Copia link'}
              title={t('social', 'copy_link_aria') || 'Copia link'}
              className={`flex flex-col items-center gap-1 py-2 rounded-xl hover:bg-white/10 transition-colors cursor-pointer ${copied ? 'text-emerald-400' : 'text-white/90'}`}
            >
              {copied ? <Check size={18} /> : <LinkIcon size={18} />}
              <span className="text-[9px] leading-none text-white/60">{copied ? 'OK' : 'Link'}</span>
            </button>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
